<template>
  <a-dropdown>
    <a-button type="default" ghost icon="global">{{$t('common.language.change')}}</a-button>
    <a-menu slot="overlay">
      <a-menu-item>
        <a href="javascript:;" title="简体中文" @click="changeLanguage('cn')">简体中文</a>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript:;" title="English" @click="changeLanguage('en')">English</a>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript:;" title="Українська" @click="changeLanguage('uk')">Українська</a>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript:;" title="Русский" @click="changeLanguage('ru')">Русский</a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
export default {
  methods: {
    changeLanguage(code) {
      switch (code) {
        case "cn":
          this.$i18n.locale = "zh-CN";
          break;
        case "en":
          this.$i18n.locale = "en-US";
          break;
        case "uk":
          this.$i18n.locale = "uk-UK";
          break;
        case "ru":
          this.$i18n.locale = "ru-RU";
          break;
        default:
          break;
      }
      localStorage.setItem('lang',this.$i18n.locale)
    //   console.log(this.$i18n.locale);
    //   console.log(this.$t("common.navigation.title.home"));
    },
  },
};
</script>

<style lang="less" scoped>
</style>